import { getRelativeLocaleUrl } from "astro:i18n";

import { useScrollThreshold } from "@/hooks/useScrollThreshold";
import type { NavBarProps } from "@/types/navbar";
import { NavLogo } from "./components/NavLogo";

import { cn } from "@/lib/utils";
import {
  LeftSection,
  NavbarContainer,
  NavbarContent,
  RightSection,
  ScrolledContent,
} from "./components";

const commonHeader =
  "fixed w-full p-3 md:px-7 md:py-3 top-2 z-50 md:max-w-[1440px] bg-white-10 md:h-16 backdrop-blur-3xl md:backdrop-blur-2xl md:top-8 rounded-xl w-[calc(100%-18px)]";

const INITIAL_THRESHOLD = 210;

const MAIN_PATHS = [
  "/overview",
  "/gallery",
  "/events",
  "/press-media",
] as const;

const FORCE_SCROLLED_PATHS = ["/events/", "/press-media"];

const isMainRoute = (path: string) => {
  return MAIN_PATHS.some((mainPath) => path.includes(mainPath));
};

const shouldForceScrolled = (path: string) => {
  return FORCE_SCROLLED_PATHS.some((forcePath) => path.includes(forcePath));
};
export default function NavBarPublicProfile({
  astroUrl,
  classNamesHeader,
  artistData,
  lang,
}: NavBarProps) {
  const LOGO = `${import.meta.env.PUBLIC_STORAGE_URL}/app-images/assets/logotipo/IsoLogoBlanco.svg`;
  const HOME_URL = getRelativeLocaleUrl(`${lang}`, "");
  const currentPath = astroUrl.pathname;

  const { isScrolled } = useScrollThreshold({
    initialThreshold: INITIAL_THRESHOLD,
    defaultScrolled: shouldForceScrolled(currentPath),
  });

  const classNameHeader = cn(commonHeader, classNamesHeader);

  const isMainPath = isMainRoute(currentPath);

  return (
    <header className={classNameHeader}>
      <NavbarContainer>
        <NavbarContent>
          <LeftSection>
            {/* <MenuButton /> */}
            <NavLogo
              homeURL={HOME_URL}
              logoUrl={LOGO}
              isVisible={!isScrolled}
            />
            <ScrolledContent
              artistData={artistData}
              astroUrl={astroUrl}
              isScrolled={isScrolled}
              isNested={isMainPath}
              defaultScrolled={shouldForceScrolled(currentPath)}
              lang={lang}
            />
          </LeftSection>
          <RightSection
            isScrolled={isScrolled}
            lang={lang}
            astroUrl={astroUrl}
            artistData={artistData}
          />
        </NavbarContent>
      </NavbarContainer>
    </header>
  );
}
